module.exports = __webpack_public_path__ + "static/savantPowerLogoGroup-da2ff2bde4bd8b6e6fb16e645552576b.png";